import React, {useEffect, useRef, useState} from 'react';
import './MinicartTotal.less';
import {convertPrice} from "helpers/format.helper";

export const MinicartTotal = ({price}) => {
	const [isBouncing, setIsBouncing] = useState(false);
	const didMountRef = useRef(false);

	useEffect(() => {
		if (!didMountRef.current) {
			didMountRef.current = true;
			return;
		}

		setIsBouncing(true);
		setTimeout(() => {
			setIsBouncing(false);
		}, 500);

	}, [price]);

	return <span
		className={`minicart-total ${isBouncing ? 'minicart-total--bouncing' : ''}`}>{convertPrice(price)}</span>;
};
